import React from "react";
import Modal from "react-modal";
import moment from "moment";

import { useDispatch, useSelector } from "react-redux";
import {
	closePrintPermisoModal,
	startDisableSaveButton,
	unsetOnSubmitData,
	startEnablePrintButton,
	setEnEspera,
	unsetEnEspera,
	startEnableSaveButton,
	startDisablePrintButton,
} from "../../actions/altaPermisos";
import { unsetCultivoAnteriorSelected, unsetCultivoSelected } from "../../actions/cultivos";
import { unsetPermisosComplemento, unsetProductorSelected } from "../../actions/productores";
import { unsetUsuarioSelected } from "../../actions/usuarios";
import { roundToN } from "../../helpers/functions/roundToN";
import { savePermitTransaction } from "../../helpers/DB/savePermitTransaction";

const customStyles = {
	content: {
		width: "1125px",
		height: "1500px",
		overflow: "auto",
	},
};

export const PrintPermisoModal = ({ data, isNew, formValues, setValues = () => {} }) => {
	const { openPrintPermisoModal, enableSaveButton, enablePrintButton, enEspera } = useSelector(
		(state) => state.altaPermisos
	);

	const dispatch = useDispatch();

	const closeModal = () => {
		dispatch(closePrintPermisoModal());
		dispatch(unsetOnSubmitData());
		dispatch(unsetCultivoSelected());
		dispatch(unsetCultivoAnteriorSelected());
		dispatch(unsetProductorSelected());
		dispatch(unsetUsuarioSelected());
		dispatch(startEnableSaveButton());
		dispatch(startDisablePrintButton());
		dispatch(unsetEnEspera());
		dispatch(unsetPermisosComplemento());
		setValues({ ...formValues, observaciones: "" });
	};

	const handleSavePermiso = async () => {
		dispatch(startDisableSaveButton());
		dispatch(setEnEspera());

		const isSave = await savePermitTransaction(data);

		if (isSave) {
			dispatch(unsetEnEspera());
			dispatch(startEnablePrintButton());
		} else {
			dispatch(unsetEnEspera());
			dispatch(startEnableSaveButton());
		}
	};

	const imprimir = () => {
		// El overlay del modal es fixed: si la ventana está desplazada, el navegador
		// lo imprime recortado (o repartido en dos hojas), así que se imprime desde arriba
		window.scrollTo(0, 0);
		window.print();
	};

	const toUpper = (string) => {
		let str = "";
		if (string) str = string;
		return str.toUpperCase();
	};

	const getDotacion = (sistema) => {
		if (sistema === "Gravedad") return data.dotacionGravedad;
		if (sistema === "Pozo Federal") return data.dotacionPozo;
		if (sistema === "Pozo Particular") return data.dotacionPozo;
	};

	const defineModulo = () => {
		switch (data.modulo) {
			case "UNI01":
			case "UNI02":
			case "UNI03":
				if (data.zona === 9) return "9A";
				else if (data.zona === 92) return "9B";
				else return data.zona;

			default:
				return data.zona;
		}
	};

	const defineTituloFirmaTitular = () => {
		switch (data.modulo) {
			case "UNI01":
			case "UNI02":
			case "UNI03":
				return "ENCARGADO/A";

			default:
				return "PRESIDENTE";
		}
	};

	return (
		<Modal
			isOpen={openPrintPermisoModal}
			onRequestClose={closeModal}
			style={customStyles}
			closeTimeoutMS={200}
			className="printModal pl-5 pr-5 pb-0 mb-0"
			overlayClassName="modal-fondo"
			bodyOpenClassName="imprimiendo-permiso"
			htmlOpenClassName="imprimiendo-permiso"
		>
			{/* Marca de agua ***************************************************************** */}

			{data.estadoPermiso === "activo" ? (
				<></>
			) : (
				<div className="watermark rotar">{data.estadoPermiso}</div>
			)}

			{/* Header ************************************************************************ */}

			<div className="row mt-5"></div>

			<div className="row mt-5 d-flex justify-content-center">
				<div className="col-3 d-flex flex-column justify-content-center">
					{/* <div className="d-flex justify-content-center">
						<img src={"./logos/sader.png"} alt="Logo SADER" style={{ maxHeight: 35 }} />
					</div>
					<div className="d-flex justify-content-center mt-3">
						<img src={"./logos/srl.png"} alt="Logo CRL" style={{ maxHeight: 70 }} />
					</div>
					<div className="d-flex justify-content-center">
						<span className="printPermisoSubLogo">DISTRITO DE RIEGO RÍO COLORADO</span>
					</div>
					<div className="d-flex justify-content-center">
						<span className="printPermisoSubLogo">S DE R.L. DE I.P. DE C.V.</span>
					</div>
					<div className="border border-dark rounded d-flex justify-content-left mt-4 w-200">Folio: </div> */}
				</div>

				<div className="col-6 d-flex flex-column justify-content-center">
					{/* <h1 className="d-flex justify-content-center">
						<b>PERMISO ÚNICO DE SIEMBRA</b>
					</h1>
					<h3 className="d-flex justify-content-center">
						<b>DISTRITO DE RIEGO 014 RÍO COLORADO</b>
					</h3> */}
					<h2 className="d-flex justify-content-center">
						<b>Ciclo Agrícola {data.ciclo}</b>
					</h2>
					{/* <h3 className="d-flex flex-column justify-content-center">
						<div>{data.direccion}</div>
					</h3> */}
				</div>

				<div className="col-3 d-flex flex-column justify-content-center">
					<div className="d-flex justify-content-center">
						{/* <img
							src={"./logos/cna.png"}
							alt="Logo comisión nacional del agua"
							style={{ maxHeight: 50 }}
						/> */}
					</div>
					<div className="border border-dark rounded d-flex justify-content-center">
						<h2 className="m-0">
							<b>Folio: {data.numeroPermiso}</b>
						</h2>
					</div>
					<div className="d-flex justify-content-center">
						{moment(data.fechaEmicion).format("DD/MM/YYYY")}
					</div>
				</div>
			</div>

			{/* Datos del usuario ******************************************************************* */}
			<div className="row mt-4"></div>
			<div className="row mt-5"></div>
			<h3 className="row d-flex justify-content-center">
				<div>{data.direccion}</div>
			</h3>
			<div className="row m-3 d-flex flex-column justify-content-center border border-dark rounded">
				<div className="d-flex justify-content-center ">DATOS DEL USUARIO</div>

				<div className="d-flex justify-content-center border-top border-dark p-1 pb-0">
					<div>
						El/la C.<b> {data.usuario}</b> con cuenta: <b>{data.cuenta}</b> tiene un derecho normal
						de <b>{data.supDerecho} </b>
						hectáreas del lote: <b>{data.lote}</b> en la colonia/ejido <b>{data.nombreLocalidad}</b>
						, <b>{data.municipio}</b>, <b>{data.estado}</b>. Módulo <b>{defineModulo()}</b>, sección{" "}
						<b>{data.seccion}</b> del canal <b>{data.canal}</b> toma <b>{data.toma}</b> con sistema
						de riego por <b>{data.sistema}</b>.<br />
						{data.reacomodo && <b> Reacomodo: {data.reacomodo}</b>}
					</div>
				</div>
			</div>

			{/* Parrafo legal ********************************************************************** */}

			<div className="row m-3 d-flex flex-column justify-content-center">
				<p className="paragraph mb-1" style={{ fontSize: 12, lineHeight: 1.3 }}>
					Con base en los instrumentos de coordinación y concertación aplicables celebrados entre
					la Secretaría de Agricultura y Desarrollo Rural, la Comisión Nacional del Agua y las
					organizaciones de usuarios del agua del Distrito de Riego 014, para regular de manera
					ordenada la programación agrícola y la expedición de Permisos Únicos de Siembra con
					Derecho de Riego; y con fundamento en los artículos 66, 67, 68, 69, 69 Bis y 70 de la Ley
					de Aguas Nacionales y demás disposiciones reglamentarias aplicables; en la Ley Federal de
					Sanidad Vegetal y su Reglamento; en la Norma Oficial Mexicana NOM-081-FITO-2001, relativa
					al manejo y eliminación de focos de infestación de plagas mediante el establecimiento o
					reordenamiento de fechas de siembra, cosecha y destrucción de residuos y todas aquellas
					Normas Oficiales Mexicanas aplicables al cultivo de que se trate; así como en los
					acuerdos, disposiciones, campañas y medidas fitosanitarias que, en el ámbito de sus
					atribuciones, determine la Secretaría de Agricultura y Desarrollo Rural, a través del
					Servicio Nacional de Sanidad, Inocuidad y Calidad Agroalimentaria, se expide el presente
					Permiso Único de Siembra para establecer exclusivamente el cultivo, superficie y volumen
					de agua que en el mismo se autorizan.
				</p>
				<p className="paragraph mb-0" style={{ fontSize: 12, lineHeight: 1.3 }}>
					La persona usuaria deberá sujetarse al plan de riegos y de siembra aprobado para el ciclo
					agrícola correspondiente, a la disponibilidad y dotación de agua autorizada, así como a
					las disposiciones fitosanitarias aplicables al cultivo de que se trate. El establecimiento
					de superficies adicionales, de cultivos distintos a los autorizados o de siembras no
					comprendidas en los planes de riego y de siembra autorizados por las autoridades
					competentes será causa de suspensión del derecho a contar con el servicio de riego, en
					términos de la Ley de Aguas Nacionales, sin perjuicio de las demás medidas
					administrativas, fitosanitarias o sanciones que resulten procedentes.
				</p>
			</div>

			{/* Detalle de cultivo y superficie ***************************************************** */}

			<div className="row m-3 mt-0 d-flex">
				<div className="col-4 d-flex flex-column border border-dark rounded p-0">
					<div className="d-flex justify-content-center ">DETALLES DEL CULTIVO</div>
					<div className="border-top border-dark p-1">
						Tipo de permiso: <b>{toUpper(data.tipo)}</b>
						<br />
						Cultivo:{" "}
						<b>
							{data.nombreCultivo} (Clave: {data.claveCultivo})
						</b>
						<br />
						Subciclo: <b>{data.subciclo}</b>
						<br />
						Superficie autorizada: <b>{data.supAutorizada} ha</b>
						<br />
						Fecha límite de siembra: <b>{moment(data.fechaLimite).format("DD/MM/YYYY")}</b>
						<br />
					</div>
				</div>

				<div className="col-1"></div>

				<div className="col-7 d-flex flex-column border border-dark rounded">
					<div className="d-flex justify-content-center ">SUPERFICIE Y DOTACIÓN VOLUMÉTRICA</div>
					<div className="row border-top border-dark d-flex text-dotacion">
						<div className="col-3 border">
							<div>Descripción</div>
						</div>
						<div className="col-2 border">
							<div>Derecho de riego</div>
						</div>
						<div className="col-2 border">
							<div>Utilizada Previamente</div>
						</div>
						<div className="col-3 border">
							<div>Autorizada en este permiso</div>
						</div>
						<div className="col-2 border">
							<div>Disponible</div>
						</div>
					</div>

					<div className="row border-top d-flex text-dotacion">
						<div className="col-3 border">
							<div>Hectáreas</div>
						</div>
						<div className="col-2 border">
							<div>{data.supDerecho}</div>
						</div>
						<div className="col-2 border">
							<div>{data.supPrevia}</div>
						</div>
						<div className="col-3 border">
							<div>{data.supAutorizada}</div>
						</div>
						<div className="col-2 border">
							<div>{roundToN(data.supDerecho - data.supPrevia - data.supAutorizada, 3)}</div>
						</div>
					</div>

					<div className="row border-top d-flex text-dotacion">
						<div className="col-3 border p-0">
							<div className="p-0 ml-2" style={{ fontSize: 12 }}>
								l.p.s./24 hrs en Parcela
							</div>
						</div>
						<div className="col-2 border align-self-start">
							<div>{roundToN(data.supDerecho * getDotacion(data.sistema), 3)}</div>
						</div>
						<div className="col-2 border align-self-start">
							<div>{roundToN(data.supPrevia * getDotacion(data.sistema), 3)}</div>
						</div>
						<div className="col-3 border align-self-start">
							<div>{roundToN(data.supAutorizada * getDotacion(data.sistema), 3)}</div>
						</div>
						<div className="col-2 border align-self-start">
							<div>
								{roundToN(
									(data.supDerecho - data.supPrevia - data.supAutorizada) *
										getDotacion(data.sistema),
									3
								)}
							</div>
						</div>
						<div className="">
							<div className="ml-2" style={{ fontSize: 12, lineHeight: 1.3 }}>
								El derecho de riego indicado en el presente Permiso Único de Siembra corresponde a
								condiciones Normales y está sujeta a los ajustes derivados de las Actas 323 y 334 de
								la Comisión Internacional de Límites y Aguas –CILA- y de la reducción de volumen para
								uso agrícola con motivo de la asignación/concesión otorgada por la Comisión Nacional
								del Agua de volumen para uso público urbano a las ciudades. No incluye volúmenes
								complementarios para cultivos de alto consumo, cuya gestión y obtención será
								responsabilidad del usuario o productor conforme a la normatividad aplicable.
							</div>
						</div>
					</div>
				</div>
			</div>

			{/* Datos complementarios  ************************************************************* */}

			<div className="row m-3 d-flex">
				<div className="col-4 d-flex flex-column border border-dark rounded p-0">
					<div className="d-flex justify-content-center ">DATOS COMPLEMENTARIOS</div>
					<div className="border-top border-dark p-1">
						Cultivo Anterior: <b>{data.cultivoAnterior}</b>
						<br />
						Fuente de crédito: <b>{data.fuenteCredito}</b>
						<br />
						Variedad: <b>{data.variedad}</b>
						<br />
						Productor:{" "}
						<b>
							{data.nombreProductor} ({data.curpProductor})
						</b>
						<br />
					</div>
				</div>

				<div className="col-1"></div>

				<div className="col-7 d-flex flex-column p-0">
					{/* Observaciones  ************************************************************* */}
					<div className="border border-dark rounded">
						<div className="d-flex justify-content-center ">OBSERVACIONES</div>
						<div className="border-top border-dark d-flex text-dotacion p-1">
							<p>{data.observaciones}</p>
						</div>
					</div>

					{/* Transferencia  ************************************************************* */}
					<div className="border border-dark rounded mt-3 p-2">
						{/* <div className="d-flex justify-content-center ">TRANSFERENCIA</div>
						<div className="border-top border-dark d-flex text-dotacion p-1">
							<p>{data.transferencia}</p>
						</div> */}

						{data.transferencia &&
							data.transferencia.length > 0 &&
							`TRANSFERENCIA INTERNA: ${data.transferencia}`}

						{data.mensajeFijo && `  ${data.mensajeFijo}`}
					</div>
				</div>
			</div>

			{/* Firmas  ************************************************************* */}

			<div className="row">
				<div className="col-4 d-flex flex-column">
					<div className="border-top border-dark firma d-flex justify-content-center">Módulo</div>
					<div className="d-flex justify-content-center">
						<b>{data.titular}</b>
					</div>
					<div className="d-flex justify-content-center">{defineTituloFirmaTitular()}</div>
				</div>
				<div className="col-4 d-flex flex-column">
					<div className="border-top border-dark firma d-flex justify-content-center">
						Sanidad Vegetal
					</div>
				</div>
				<div className="col-4 d-flex flex-column">
					<div className="border-top border-dark firma d-flex justify-content-center">
						FIRMA DEL USUARIO
					</div>
					<div className="d-flex justify-content-center">
						<b>{data.usuario}</b>
					</div>
					<div className="d-flex justify-content-center">Acepto de conformidad</div>
				</div>
			</div>

			{/* Advertencias  ************************************************************* */}

			<p className="row m-2">
				<b>
					<u>
						ADVERTENCIAS: (1) Es responsabilidad del usuario de este permiso, disponer de la
						totalidad del volumen adicional requerido por el cultivo a establecer. (2) Para los
						sistemas de Gravedad y Pozo Federal un derecho de riego de 20 ha cubre una superficie
						sembrada para el cultivo de Trigo = 16 ha, Algodón = 10 ha, Alfalfa = 10 ha, Espárrago =
						10 ha y Sorgo forrajero temprano = 13 ha.
					</u>
				</b>
			</p>

			{/* Encavezado sanidad  ************************************************************* */}
			<div className="row m-3 mt-2">
				<div className="col-2"></div>
				<div className="col-10">
					<div className="row d-flex justify-content-between">
						<div className="border border-dark rounded mt-2 p-2">Folio: {data.numeroPermiso}</div>
						{data.costoSanidades > 0 && (
							<div className="border border-dark rounded mt-2 p-2">
								Cuota Apoyo a Sanidades: $ {roundToN(data.costoSanidades * data.supAutorizada, 3)}{" "}
								pesos M.N.
							</div>
						)}
						<div className="border border-dark rounded mt-2 p-2">
							Bueno por: $ {roundToN(data.cuotaCultivo * data.supAutorizada, 3)} pesos M.N.
						</div>
					</div>

					{/* Resivo Sanidad  ************************************************************* */}

					<div className="row">
						<u>
							Recibimos de El/la C.{" "}
							<b>
								{data.usuario} la cantidad de {roundToN(data.cuotaCultivo * data.supAutorizada, 3)}{" "}
								pesos M.N.
							</b>{" "}
							Por concepto de aportación a las campañas Fitosanitarias, para el sostenimiento del
							Comité Estatal de Sanidad Vegetal.
						</u>
					</div>
				</div>
			</div>

			{/* Datos usuario sanidad  ************************************************************* */}

			<div className="row m-3">
				<div className="col-2 d-flex flex-column">
					{/* <div className="d-flex justify-content-center">
						<img src={"./logos/cesvbc.webp"} alt="Logo sanidad vegetal" style={{ maxHeight: 70 }} />
					</div>
					<div className="d-flex justify-content-center font12">COMITÉ ESTATAL DE</div>
					<div className="d-flex justify-content-center font12">SANIDAD VEGETAL DE</div>
					<div className="d-flex justify-content-center font12">BAJA CALIFORNIA</div> */}
				</div>

				<div className="col-10 d-flex flex-column border border-dark rounded p-0">
					<div className="d-flex justify-content-center border-bottom border-dark">
						DATOS DEL USUARIO
					</div>

					<p className="m-2">
						El/la C.<b> {data.usuario}</b> con cuenta: <b>{data.cuenta}</b> tiene un derecho normal
						de <b>{data.supDerecho} </b>
						hectáreas del lote: <b>{data.lote}</b> en la colonia <b>{data.nombreLocalidad}</b>,{" "}
						<b>{data.municipio}</b>, <b>{data.estado}</b>. Módulo <b>{defineModulo()}</b>, sección{" "}
						<b>{data.seccion}</b> del canal <b>{data.canal}</b> toma <b>{data.toma}</b> con sistema
						de riego por <b>{data.sistema}</b>.
					</p>
				</div>
			</div>

			{/* Logo sanidad  y botones************************************************************* */}

			<div className="row mb-0 pb-0">
				<div className="col-12 d-flex justify-content-center align-items-center pt-2">
					{enableSaveButton ? (
						isNew ? (
							<button
								type="submit"
								className="btn btn-outline-primary ml-5 d-print-none"
								onClick={handleSavePermiso}
							>
								<i className="far fa-save"></i>
								<span> Guardar</span>
							</button>
						) : (
							<button
								type="button"
								className="btn btn-outline-primary ml-5 d-print-none"
								onClick={imprimir}
							>
								<i className="fas fa-print"></i>
								<span> Imprimir</span>
							</button>
						)
					) : (
						<></>
					)}

					{enEspera ? (
						<div className="spinner-border border-dark text-primary" role="status">
							<span className="sr-only">Loading...</span>
						</div>
					) : (
						<></>
					)}

					{enablePrintButton ? (
						<button
							type="button"
							className="btn btn-outline-primary ml-5 d-print-none"
							onClick={imprimir}
						>
							<i className="fas fa-print"></i>
							<span> Imprimir</span>
						</button>
					) : (
						<></>
					)}

					<button
						type="button"
						className="btn btn-outline-primary ml-5 d-print-none ml-3"
						onClick={closeModal}
					>
						<i className="fas fa-sign-out-alt"></i>
						<span> Cerrar</span>
					</button>
				</div>
			</div>
		</Modal>
	);
};
